import { algoliasearch } from 'algoliasearch'

export const useAlgolia = async ({ requests = [], fetchOnLoad = true }) => {
  const runtimeConfig = useRuntimeConfig()
  // const route = useRoute()

  const client = algoliasearch(
    runtimeConfig.public.algolia.id,
    runtimeConfig.public.algolia.key,
  )

  // Verifica se 'requests' è un ref e, in tal caso, assegna 'requests' a 'requestsRef'.
  // In caso contrario, converte 'requests' in un ref e assegna il risultato a 'requestsRef'.
  const requestsRef = isRef(requests) ? requests : ref(requests)

  // Definisce una variabile reattiva per memorizzare i dati della ricerca
  const data = ref(null)

  // Funzione per eseguire la ricerca su Algolia
  const performSearch = async () => {
    try {
      // Esegue la ricerca utilizzando il client Algolia e le richieste specificate
      const response = await client.search({
        requests: requestsRef.value,
      })
      // Memorizza la risposta della ricerca nella variabile 'data'
      data.value = response

      return response
    } catch (err) {
      // Gestisce eventuali errori durante la ricerca
      console.error('Errore durante il recupero dei dati:', err)
      return {}
    }
  }

  /* if (fetchOnLoad) {
    // TODO: Rivedere questo if o usare il composable algolia del boilerplate nuxt3
    // Ricerca di default iniziale con tutti i dati
    const { data: initialData, error } = await useAsyncData(route.path, () =>
      performSearch(),
    )

    // Verifica se ci sono errori nella ricerca iniziale e li registra nella console
    if (error.value) {
      console.error(
        'Errore durante il recupero dei dati iniziali:',
        error.value,
      )
    } else {
      // Se non ci sono errori, memorizza i dati iniziali nella variabile 'data'
      data.value = initialData.value
    }
  } */

  onMounted(async () => {
    if (fetchOnLoad) {
      await performSearch()
    }
  })

  // Osserva i cambiamenti nelle richieste e riesegue la ricerca quando cambiano
  watch(
    () => requestsRef.value,
    async () => {
      await performSearch()
    },
    { deep: true },
  )

  // Ritorna la variabile 'data' che contiene i risultati della ricerca
  return {
    data,
  }
}
